<template>
    <div class="dropdown nav-item message-dropdown btn-group" >
        <a href="javascript:;" id="ddlmsg" data-bs-toggle="dropdown" @click="getActivityLogsRequest" :title="t('activity_log')" aria-expanded="false" class="btn dropdown-toggle btn-icon-only nav-link">
            <ActivityLogSVG  />
        </a>
        <ul class="dropdown-menu dropdown-menu-right" aria-labelledby="ddlmsg">

            <ContentLoader 
                minHeight="50px"
                :isLoading="isLoadingActivityLog"
                v-if="isLoadingActivityLog" 
                :title="t('loading_activity')"
                />
            
            <span v-if="!isLoadingActivityLog">
                <router-link to="/activity-log" v-for="( activity, index ) in activityLogList.slice(0, 5)" :key="index"   >
                    <li role="presentation"   target="_self" class="dropdown-item" >
                        <div class="media media">
                            <div class="media-aside align-self-start">
                                <div class="avatar avatar-md">
                                    <img :src="assetsHostURL + activity.givenTo.image" class="navbar-logo" alt="User" />
                                    <span c lass="avatar-title rounded-circle">
                                    </span>
                                </div>
                            </div>
                            <div class="media-body">
                                <h5 class="usr-name">{{ activity.givenTo.fname + " " + activity.givenTo.lname }}</h5>
                                <p class="msg-title" v-html="activity.description"></p>
                            </div>
                        </div>
                    </li>
                </router-link>
        </span>
        <center >
            <label v-if="activityLogList.length > 5 && !isLoadingActivityLog"> 
                <a v-if="activityLogList.length > 5" @click="redirectToActivityLog" style="cursor: pointer;">
                    {{ "See more activities." }}
                 </a>
            </label> 
        </center> 

        <center v-if="!isLoadingActivityLog && activityLogList.length === 0">
           <label>No Activity Log</label>
        </center>
        </ul>
    </div>
</template>

<style scoped>
    img{
        height: 50px;
        width: 50px;
        margin-right: 10px;
        border-radius: 50%;
        padding: 2px;
    }

    body.dark img{
        border: 1px solid rgb(114, 111, 111);
    }
    img{
        border: 1px solid rgb(226, 221, 221);
    }
    body.dark img:hover{
        border: 1px solid white;
    }
    img:hover{
        border: 1px solid white;
    }
</style>


<script setup>
    import ActivityLogSVG from "@/components/svg/activity-log.vue" 
    import ContentLoader from "@/components/common/ContentLoader";
    import { ACTIVITY_LOG_MODULE_NAME } from "@/store/module-names";
    import { GET_ACTIVITY_LOG_REQUEST } from "@/store/modules/activity-log/action-types";
    import { ref, computed } from "vue";
    import { useStore } from 'vuex';
    const store = useStore();
    import { useI18n } from 'vue-i18n';

    const redirectToActivityLog = () => { 
        window.location.href='/activity-log'
    }
const {t} =useI18n()
    const assetsHostURL = process.env.VUE_APP_ASSESTS_BUCKET_URL

    const activityLogList =  computed(() => store.state.activityLog.activityLogList);
    const isLoadingActivityLog = ref(false);

    const getActivityLogsRequest = async ()=>{
        isLoadingActivityLog.value = true
        let response = {}
            try{
                response =  await store.dispatch( ACTIVITY_LOG_MODULE_NAME + "/" + GET_ACTIVITY_LOG_REQUEST);
            }catch(error){
                isLoadingActivityLog.value = false
            }
            isLoadingActivityLog.value = false
            return response
    }
</script>
